"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListResponseMessageAttemptOut = void 0;
class ListResponseMessageAttemptOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ListResponseMessageAttemptOut.attributeTypeMap;
    }
}
exports.ListResponseMessageAttemptOut = ListResponseMessageAttemptOut;
ListResponseMessageAttemptOut.discriminator = undefined;
ListResponseMessageAttemptOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<MessageAttemptOut>",
        "format": ""
    },
    {
        "name": "done",
        "baseName": "done",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "iterator",
        "baseName": "iterator",
        "type": "string",
        "format": ""
    },
    {
        "name": "prevIterator",
        "baseName": "prevIterator",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=ListResponseMessageAttemptOut.js.map